import { render } from "./EstadoColor.vue?vue&type=template&id=130aac0a&scoped=true"
import script from "./EstadoColor.vue?vue&type=script&lang=js"
export * from "./EstadoColor.vue?vue&type=script&lang=js"

import "./EstadoColor.vue?vue&type=style&index=0&id=130aac0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130aac0a"]])

export default __exports__